import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user.model';
import { FaviconService } from './favicon.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  // Current user session
  private localstorageUserKey:string = "signem-user";
  private currentUserSubject: BehaviorSubject<User> = new BehaviorSubject(null as any);
  public currentUser: Observable<User> = this.currentUserSubject.asObservable();

  constructor(private favicon: FaviconService) { }

  public getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  public setUser(user:User, keepAlive:boolean = true) {
    if(user!=null && user!=undefined) {
      if(keepAlive) {
        localStorage.setItem(this.localstorageUserKey, JSON.stringify(user));
      }
      this.currentUserSubject.next(user);
      this.favicon.setFromCompany(user.company);
    }
  }

  public deleteUser() {
    localStorage.removeItem(this.localstorageUserKey);
    this.currentUserSubject.next(null as any);
  }
}
